import { render } from "./WelcomeQuickNav.vue?vue&type=template&id=00bfc188&scoped=true"
import script from "./WelcomeQuickNav.vue?vue&type=script&lang=js"
export * from "./WelcomeQuickNav.vue?vue&type=script&lang=js"

import "./WelcomeQuickNav.vue?vue&type=style&index=0&id=00bfc188&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bfc188"]])

export default __exports__